import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HvSvg from 'src/components/HvSvg';
import splitDux from 'src/redux/split';
import uiDux from 'src/redux/ui';

import SliderControls from './SliderControls';
import SliderControlButtons from './SliderControlButtons';

import {
  OffsetLabel,
  SplitSliderContainer,
  TopButtonsContainer,
  TopButton,
} from './styled';

const mapStateToProps = (state) => ({
  labels: splitDux.selectors.getSplitToolLabels(state),
  isDeleteSplitButtonEnabled: splitDux.selectors.isDeleteSplitButtonEnabled(
    state,
  ),
  isOrientationChangeEnabled: splitDux.selectors.isOrientationChangeEnabled(
    state,
  ),
  getOrientationIconPath: splitDux.selectors.getOrientationIconPath(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleSwitchSplitOrientationClick:
        uiDux.actions.handleSwitchSplitOrientationClick,
      handleDeleteSplitClick: splitDux.actions.handleDeleteSplitClick,
    },
    dispatch,
  );

export class SplitSlider extends PureComponent {
  static propTypes = {
    handleSwitchSplitOrientationClick: PropTypes.func.isRequired,
    getOrientationIconPath: PropTypes.string.isRequired,
    handleDeleteSplitClick: PropTypes.func.isRequired,
    isDeleteSplitButtonEnabled: PropTypes.bool.isRequired,
    isOrientationChangeEnabled: PropTypes.bool.isRequired,
    labels: PropTypes.object.isRequired,
  };

  render() {
    const {
      handleSwitchSplitOrientationClick,
      isDeleteSplitButtonEnabled,
      isOrientationChangeEnabled,
      handleDeleteSplitClick,
      getOrientationIconPath,
      labels: { maxOffsetLabel, minOffsetLabel },
    } = this.props;

    return (
      <SplitSliderContainer>
        <TopButtonsContainer>
          <TopButton
            innerRef={(el) => {
              this.toggle = el;
            }}
            onClick={() => {
              this.toggle.blur();
              handleSwitchSplitOrientationClick();
            }}
            disabled={!isOrientationChangeEnabled}
            data-selenium="rotateSplitButton"
          >
            <HvSvg src={getOrientationIconPath} />
          </TopButton>
          <TopButton
            onClick={handleDeleteSplitClick}
            disabled={!isDeleteSplitButtonEnabled}
            data-selenium="deleteSplitButton"
          >
            <HvSvg
              src={require('src/assets/images/toolSplitDelete_enabled.svg')}
            />
          </TopButton>
        </TopButtonsContainer>
        <OffsetLabel data-selenium="maxOffsetLabel">
          {maxOffsetLabel}
        </OffsetLabel>
        <SliderControls />
        <OffsetLabel data-selenium="minOffsetLabel">
          {minOffsetLabel}
        </OffsetLabel>
        <SliderControlButtons />
      </SplitSliderContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SplitSlider);
